(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["valca-rt-design"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('valca-rt')) {
    customElements.define('valca-rt', class extends HTMLElement {
      connectedCallback() {
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.reveal = () => {
          this.observer?.disconnect();
          this.querySelectorAll('[data-vrt-reveal]').forEach(node => node.classList.remove('vrt-await'));
          if (this.motion.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
          this.classList.add('vrt-reveal-ready');
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.remove('vrt-await');
                this.observer.unobserve(entry.target);
              }
            });
          }, { threshold:0, rootMargin:'0px 0px -30px 0px' });
          this.querySelectorAll('[data-vrt-reveal]').forEach(node => {
            if (node.getBoundingClientRect().top > window.innerHeight) {
              node.classList.add('vrt-await');
              this.observer.observe(node);
            }
          });
        };
        this.reveal();
        // All listeners are removed when Shopify reloads a section in the editor.
        this.uiAbort?.abort();
        this.uiAbort = new AbortController();
        const signal = this.uiAbort.signal;
        const scrollBehavior = () => this.motion.matches ? 'auto' : 'smooth';
        const carousel = this.querySelector('[data-vrt-carousel]');
        if (carousel) {
          const prev = this.querySelector('[data-vrt-prev]');
          const next = this.querySelector('[data-vrt-next]');
          const status = this.querySelector('[data-vrt-position]');
          const update = () => {
            const cards = [...carousel.children];
            const closest = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - cards[0].offsetLeft - carousel.scrollLeft) < Math.abs(cards[best].offsetLeft - cards[0].offsetLeft - carousel.scrollLeft) ? i : best, 0);
            prev.disabled = carousel.scrollLeft < 2;
            next.disabled = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 3;
            if (status) status.textContent = `${closest + 1} / ${cards.length}`;
          };
          const move = direction => {
            const step = carousel.children[1] ? carousel.children[1].offsetLeft - carousel.children[0].offsetLeft : carousel.clientWidth;
            carousel.scrollBy({left: direction * step, behavior: scrollBehavior()});
          };
          prev.addEventListener('click', () => move(-1), {signal});
          next.addEventListener('click', () => move(1), {signal});
          carousel.addEventListener('scroll', update, {passive:true, signal});
          carousel.addEventListener('keydown', event => {
            if (event.target !== carousel) return;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();move(event.key === 'ArrowRight' ? 1 : -1);}
          }, {signal});
          this.carouselResize = new ResizeObserver(update);this.carouselResize.observe(carousel);update();
          if (this.classList.contains('vrt-mode-reviews') && carousel.children.length > 1) {
            let stopped = false;
            let hovered = false;
            let focused = false;
            let visible = false;
            const nav = this.querySelector('.vrt-carousel-nav');
            let toggle = this.querySelector('[data-vrt-autoplay]');
            if (!toggle && nav) {
              toggle = document.createElement('button');
              toggle.type = 'button';
              toggle.className = 'vrt-autoplay-toggle';
              toggle.setAttribute('data-vrt-autoplay', '');
              nav.append(toggle);
            }
            const sync = () => {
              clearTimeout(this.reviewAutoplayTimer);
              const reduced = this.motion.matches;
              if (toggle) {
                toggle.textContent = stopped || reduced ? 'Reanudar' : 'Pausar';
                toggle.setAttribute('aria-label', stopped || reduced ? 'Reanudar testimonios automáticos' : 'Pausar testimonios automáticos');
                toggle.disabled = reduced;
              }
              if (status) status.setAttribute('aria-live', stopped || reduced ? 'polite' : 'off');
              if (stopped || hovered || focused || !visible || document.hidden || reduced || !this.isConnected) return;
              this.reviewAutoplayTimer = setTimeout(() => {
                const atEnd = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth - 3;
                if (atEnd) carousel.scrollTo({left:0, behavior:scrollBehavior()});
                else move(1);
                sync();
              }, 4000);
            };
            const stop = event => {
              if (event?.target instanceof Element && event.target.closest('[data-vrt-autoplay]')) return;
              stopped = true;
              sync();
            };
            this.addEventListener('pointerenter', event => {
              if (event.pointerType === 'mouse' || event.pointerType === 'pen') { hovered = true; sync(); }
            }, {signal});
            this.addEventListener('pointerleave', () => { hovered = false; sync(); }, {signal});
            this.addEventListener('focusin', () => { focused = true; sync(); }, {signal});
            this.addEventListener('focusout', () => {
              queueMicrotask(() => { if (signal.aborted) return; focused = this.contains(document.activeElement); sync(); });
            }, {signal});
            this.addEventListener('pointerdown', stop, {signal, passive:true});
            this.addEventListener('click', stop, {signal});
            this.addEventListener('keydown', event => {
              if (['ArrowLeft','ArrowRight','Enter',' '].includes(event.key)) stop(event);
            }, {signal});
            carousel.addEventListener('wheel', stop, {signal, passive:true});
            this.addEventListener('shopify:block:select', stop, {signal});
            this.addEventListener('shopify:section:select', stop, {signal});
            toggle?.addEventListener('click', () => { stopped = !stopped; sync(); }, {signal});
            document.addEventListener('visibilitychange', sync, {signal});
            this.motion.addEventListener('change', sync, {signal});
            this.reviewAutoplayObserver?.disconnect();
            this.reviewAutoplayObserver = new IntersectionObserver(entries => {
              visible = entries.some(entry => entry.isIntersecting);
              sync();
            }, {threshold:0});
            this.reviewAutoplayObserver.observe(carousel);
            sync();
          }

        }
        const gallery = this.querySelector('[data-vrt-gallery]');
        if (gallery) {
          const slides = [...gallery.querySelectorAll('[data-vrt-slide]')];
          const thumbs = [...gallery.querySelectorAll('[data-vrt-thumb]')];
          let current = 0;
          const show = index => {
            if (!slides.length) return;
            current = (index + slides.length) % slides.length;
            slides.forEach((slide, i) => slide.hidden = i !== current);
            thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === current)));
            const status = gallery.querySelector('[data-vrt-gallery-position]');
            if (status) status.textContent = `${current + 1} / ${slides.length}`;
            const strip = gallery.querySelector('.vrt-thumbnails');
            if (strip && thumbs[current]) strip.scrollTo({left:thumbs[current].offsetLeft - strip.offsetLeft - strip.clientWidth/2 + thumbs[current].clientWidth/2,behavior:scrollBehavior()});
          };
          gallery.addEventListener('click', event => {
            const thumb = event.target.closest('[data-vrt-thumb]');
            if (thumb) show(Number(thumb.dataset.vrtThumb));
            if (event.target.closest('[data-vrt-gallery-prev]')) show(current - 1);
            if (event.target.closest('[data-vrt-gallery-next]')) show(current + 1);
          }, {signal});
          let touchX = null, touchY = null;
          const stage = gallery.querySelector('.vrt-gallery-stage');
          stage.addEventListener('touchstart', event => {touchX=event.changedTouches[0].clientX;touchY=event.changedTouches[0].clientY;}, {passive:true,signal});
          stage.addEventListener('touchend', event => {const dx=event.changedTouches[0].clientX-touchX,dy=event.changedTouches[0].clientY-touchY;if(touchX!==null && Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.5)show(current+(dx<0?1:-1));touchX=null;}, {passive:true,signal});
        }
        const roadmap = this.querySelector('[data-vrt-roadmap]');
        if (roadmap) {
          const steps = [...roadmap.querySelectorAll('.vrt-roadmap-step')];
          const line = roadmap.querySelector('.vrt-roadmap-line');
          const fill = roadmap.querySelector('[data-vrt-progress]');
          const update = () => {
            this.roadmapFrame = null;
            if (!steps.length) return;
            const first = steps[0].querySelector('.vrt-step-number').getBoundingClientRect();
            const last = steps[steps.length-1].querySelector('.vrt-step-number').getBoundingClientRect();
            const top = first.top + first.height/2, height = last.top + last.height/2 - top;
            line.style.height = `${height}px`;line.style.bottom='auto';
            const cursor = window.innerHeight * .62;
            const progress = this.motion.matches ? 1 : Math.max(0, Math.min(1, (cursor - top)/Math.max(1,height)));
            fill.style.transform = `scaleY(${progress})`;
            steps.forEach(step => step.classList.toggle('is-active', this.motion.matches || step.querySelector('.vrt-step-number').getBoundingClientRect().top <= cursor));
          };
          const schedule = () => {if(!this.roadmapFrame)this.roadmapFrame=requestAnimationFrame(update);};
          window.addEventListener('scroll', schedule, {passive:true,signal});window.addEventListener('resize',schedule,{signal});this.motion.addEventListener('change',schedule,{signal});
          this.roadmapResize = new ResizeObserver(schedule);this.roadmapResize.observe(roadmap);update();
        }

        this.motion.addEventListener('change', this.reveal);
        this.onChange = event => {
          if (!event.target.matches('[data-vrt-variant]')) return;
          const option = event.target.selectedOptions[0];
          const price = this.querySelector('[data-vrt-price]');
          const compare = this.querySelector('[data-vrt-compare]');
          if (price) price.textContent = option.dataset.price;
          if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
          const button = this.querySelector('[data-vrt-buy-label]');
          if (button) {
            button.disabled = option.disabled;
            if (!option.disabled) button.querySelector('.button-text').textContent = button.dataset.vrtBuyLabel;
          }
        };
        this.addEventListener('change', this.onChange);
        this.onPlay = event => {
          if (event.target.tagName !== 'VIDEO') return;
          document.querySelectorAll('valca-rt video').forEach(video => { if (video !== event.target) video.pause(); });
        };
        this.addEventListener('play', this.onPlay, true);
      }
      disconnectedCallback() {
        clearTimeout(this.reviewAutoplayTimer);this.reviewAutoplayObserver?.disconnect();
        this.uiAbort?.abort();this.carouselResize?.disconnect();this.roadmapResize?.disconnect();cancelAnimationFrame(this.roadmapFrame);
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.reveal);
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('play', this.onPlay, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
